import request from "@/global/request/request";
import API from "@/global/request/api";

const columnService = {
  getColumnsList(params) {
    return request.get(API.columns, params);
  },
  getColumnsInfo(id) {
    return request.get(API.columnsInfo(id));
  },
  updateColumnsInfo(id, params) {
    return request.put(API.columnsInfo(id), params);
  },
  updateColumnsPrecis(id, params) {
    return request.put(API.columnsPrecis(id), params);
  },
  submitColumnsNodeContentVerify(id, nodeId) {
    return request.put(API.columnsNodeContentVerify(id, nodeId));
  },
  submitColumnsNodeContentVerifyInfo(id, nodeId) {
    return request.get(API.columnsNodeContentVerify(id, nodeId));
  },
  submitColumnsNodeContent(id, nodeId, params) {
    return request.put(API.columnsNodeContent(id, nodeId), params);
  },
  updateColumnsAttachment(id, nodeId, params) {
    return request.put(API.columnsAttachment(id, nodeId), params);
  }

  // columnsAttachment
};
export default columnService;
